module.exports = __webpack_public_path__ + "static/media/442414217_1120995692286578_5156368268652054738_n-min.0ce20683.jpg";